import { CustomButton } from "@/components/ui/Buttons";
import { FileDetails } from "@/types/types";
import { UploadFileToS3 } from "@/utils/uploadFilestoS3";
import { CREATOR_VIDEO_ACCEPT } from "@/utils/videoUpload";
import { DeleteIcon } from "lucide-react";
import { useState } from "react";
import { FileWithPath, useDropzone } from "react-dropzone";
import Attachment from "@/assets/icons/Attachment.svg";
import { formatFileSize } from "@/utils/formatFileSize";
import LoadingStrip from "@/components/ui/LoadinStrip";

const TestPage = () => {
  const [files, setFiles] = useState<FileDetails[]>([]);
  const [showProgress, setShowProgress] = useState<string | null>(null);
  const [uploading, setUploading] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);


  const maxFiles = 10;
  const maxSize = 100 * 1024 * 1024; // 100MB
  const accept = CREATOR_VIDEO_ACCEPT;

  const onDrop = async (acceptedFiles: FileWithPath[]) => {
    if (uploading) return;
    setUploading(true);
  
    console.log('new file droped');
    const newFiles = acceptedFiles.slice(0, maxFiles - files.length);
    const uniqueNumber = new Date().getTime();
    
    let tempFiles: FileDetails[] = [];
  
    for (const file of newFiles) {
      const fileDetails: FileDetails = {
        name: `${uniqueNumber.toString()}-${file.name}`,
        size: file.size,
        type: file.type,
        lastModified: file.lastModified,
        webkitRelativePath: file.webkitRelativePath,
        local_url: URL.createObjectURL(file),
        live_url: null,
      };
  
      tempFiles.push(fileDetails);
    }
  
    // Batch update the state once at the end
    setFiles((prevFiles) => [...prevFiles, ...tempFiles]);
  
    for (const fileDetails of tempFiles) {
      try {
        setShowProgress(fileDetails.name);
        console.log('uploadeing file ' ,fileDetails);
        const uploadedFile = await UploadFileToS3(fileDetails);
  console.log('file uploaded',uploadedFile);
        setFiles((prevFiles) =>
          prevFiles.map((f) =>
            f.name === fileDetails.name ? { ...fileDetails, live_url: uploadedFile.live_url, uploading: false } : f
          )
        );
        setShowProgress(null);
      } catch (error) {
        setShowProgress(null);
        console.error(`Failed to upload file: ${fileDetails.name}`, error);
      }
    }
  
    setUploading(false);
  };

  const handleRemoveFile = (index: number) => {
    const updatedFiles = files.filter((_, i) => i !== index);
    setUploading(false)
    setFiles(updatedFiles);
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple: true,
    maxSize,
    accept,
    noClick: true,
  });


  const [loading, setLoading] = useState(false);

  // Submit the assignment
  

  //  handle the submission date

  
  return (
    <div>
      {" "}
      <div className="relative mb-20" {...getRootProps()}>
      <input {...getInputProps()} />

       {/* File List */}
       {files.length > 0 ? (
          <div className="mt-[50px] p-5 border border-[#C3C3C3] rounded-xl">
            <p className="text-sm font-medium leading-5 mb-[18px]">
              Uploaded files
            </p>
            {files.map((file, index) => (
              <div
                key={index}
                className="border border-dashed border-[#C3C3C3] w-full my-4 overflow-hidden flex justify-between items-start rounded-[8px] p-4 bg-[#F0F3F5]"
              >
                <div className="flex w-full gap-x-[14px] items-start">
                  <div>
                    <Attachment />
                  </div>
                  <div className="w-full">
                    <p className="font-medium text-[#344054] text-caption-large">
                      {file?.name?.length > 40
                        ? `${file?.name?.slice(0, 40)}...`
                        : file?.name}
                    </p>
                    <p className="text-[#475467] text-caption-large">
                      {formatFileSize(file.size)}
                    </p>
                    <div className="pt-1">
                      {showProgress === file.name && <LoadingStrip />}
                    </div>
                    {file.live_url && (
                      <a
                        href={file.live_url}
                        target="_blank"
                        className="text-caption-regular font-medium pt-1"
                        rel="noopener noreferrer"
                      >
                        View file
                      </a>
                    )}
                  </div>
                </div>
                <div className="flex justify-end w-fit relative">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRemoveFile(index);
                    }}
                  >
                    <DeleteIcon />
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="max-w-[272px] mx-auto mt-9">
            <CustomButton
              fontSize="14px"
              fontWeight="500"
              padding="8px"
              backgroundColor="#17457D"
              borderRadius="8px"
              className="leading-5 w-full"
              onClick={() => {
                const input = document.querySelector(
                  'input[type="file"]'
                ) as HTMLInputElement;
                if (input) {
                  input.click();
                }
              }}
            >
              Upload Video Here
            </CustomButton>
          </div>
        )}
      </div>
    </div>
  );
};

export default TestPage;
